export const WMG1_APP_NAME = 'WMG1';

export const USER_MANAGEMENT_PERMISSION = 'USER_MANAGEMENT.VIEW';
export const CREATE_ROLE_PERMISSION = 'USER_RESOURCE_ROLE.CREATE';
export const DELETE_ROLE_PERMISSION = 'USER_RESOURCE_ROLE.DELETE';
